import React, { CSSProperties, useMemo } from "react";
import styled from "@emotion/styled";
import Typography from "@mui/material/Typography";
import { GameServerState } from "../../services/backend/GameServerService";
import { LedIndicator, LedIndicatorColor } from "../../components/LedIndicator";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export interface GameServerStateIndicatorProps {
  state: GameServerState;
  style?: CSSProperties;
}

export const GameServerStateIndicator = ({ state, style }: GameServerStateIndicatorProps) => {
  const [label, color] = useMemo(() => {
    switch (state) {
      case GameServerState.STOPPED:
        return ["Stopped", LedIndicatorColor.GRAY];
      case GameServerState.UNHEALTHY:
        return ["Unhealthy", LedIndicatorColor.RED];
      case GameServerState.RUNNING:
        return ["Running", LedIndicatorColor.GREEN];
      case GameServerState.STANDBY:
        return ["Standby", LedIndicatorColor.BLUE];
      case GameServerState.UNKNOWN:
      default:
        return ["Unknown", LedIndicatorColor.YELLOW];
    }
  }, [state]);
  return (
    <Container style={style}>
      <Typography variant="inherit" style={{ marginRight: 8 }}>
        {label}
      </Typography>
      <LedIndicator color={color} scale={0.2} />
    </Container>
  );
};
